<script setup lang="ts">
import { onMounted, ref } from 'vue'
import {
    ExternalKycProcessChangesResponse,
    getExternalKycProcessChanges,
    postExternalKycProcessOverwriteNaturalProfile,
} from '../../../../utilities/api'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'

const changeset = ref<ExternalKycProcessChangesResponse>(null)

const loading = ref(false)

onMounted(() => {
    getExternalKycProcessChanges().then((result) => {
        changeset.value = result.data
    })
})

function overrideData() {
    loading.value = true
    postExternalKycProcessOverwriteNaturalProfile()
        .then(() => {
            const state = usePersonalAccountDataState()
            state.fetchAccountData()
            loading.value = false
        })
        .catch(() => {
            loading.value = false
        })
}
</script>

<template>
    <div class="text-left">
        <div class="font-semibold text-gray-700">{{ $t('verification.status_data_changed') }}</div>

        <div v-if="changeset?.length === 0" class="py-6 pb-6">
            {{ $t('verification.no_changes') }}
        </div>

        <div v-else class="pb-6 pr-0 md:pr-6">
            <table class="w-full table-auto text-sm">
                <thead class="border-b border-gray-300">
                    <tr>
                        <th class="py-1"></th>
                        <th class="py-1">{{ $t('verification.old_value') }}</th>
                        <th class="py-1">{{ $t('verification.new_value') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="change in changeset" :key="change.key">
                        <td class="py-1">{{ $t('account.' + change.key) }}</td>
                        <td class="py-1">{{ change.old }}</td>
                        <td class="py-1">{{ change.new }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <BaseButtonMuted size="lg" :disabled="loading" :loading="loading" @click="overrideData">
            <span class="font-bold">{{
                $t(changeset?.length ? 'verification.override_data' : 'verification.save')
            }}</span>
        </BaseButtonMuted>
    </div>
</template>
